<template>
    <div
        class="
            q10__page
            w-full
            min-h-screen
            bg-gray-50 bg-cover bg-center bg-norepeat
            block
            md:flex
            flex-col
            xl:flex-row
            q10__overlay_desktop
        "
        :style="{
            backgroundImage:
                'url(' +
                $i18n.locale +
                '/images/pages/' +
                currentPage.slug +
                '/' +
                'jumbotron.jpg)',
        }"
    >
        <div class="absolute bottom-2 right-1 hidden lg:block">
            <div class="text-xs text-white">
                {{ currentPage.content.sTextImage004.text }}
            </div>
        </div>
        <div>
            <img
                class="curve-image"
                :src="
                    $i18n.locale +
                    '/images/pages/' +
                    currentPage.slug +
                    '/' +
                    'curba.png'
                "
            />
        </div>

        <div class="block md:hidden w-full h-auto relative">
            <img
                class="block relative"
                :src="
                    $i18n.locale +
                    '/images/pages/' +
                    currentPage.slug +
                    '/' +
                    'jumbotron.jpg'
                "
                style="min-height: 235px"
            />

            <div class="absolute top-16 left-10 w-3/5 text-white">
                <div class="text-xl mb-3 uppercase leading-none">
                    {{ currentPage.content.sTextImage001.text }}
                </div>
                <div class="text-lg uppercase leading-none whitespace-nowrap">
                    {{ currentPage.content.sTextImage002.text }}
                </div>
            </div>

            <div class="absolute bottom-5 left-5">
                <div class="hidden md:text-sm text-white">
                    {{ currentPage.content.sTextImage003.text }}
                </div>
            </div>
            <div class="absolute bottom-5 right-5">
                <div class="text-xs text-white">
                    {{ currentPage.content.sTextImage004.text }}
                </div>
            </div>
        </div>

        <div
            class="
                relative
                xl:absolute
                hidden
                md:block
                xl:top-5
                top-0
                xl:left-0
                left-0
                w-full
                text-center
                uppercase
                text-gray-500
            "
        >
            <div class="container px-11 2xl:px-3 m-auto">
                <span
                    v-html="currentPage.content.sTextImage001.text"
                    class="mr-10 text-lg text-white"
                ></span>
                <span
                    class="text-white"
                    v-html="currentPage.content.sTextImage002.text"
                ></span>
            </div>
        </div>

        <div
            class="
                relative
                xl:absolute
                hidden
                md:block
                top-0
                xl:top-28 xl:left-0
                left-0
                w-full
                text-right
                uppercase
                text-white
            "
        ></div>

        <div class="container px-11 2xl:px-3 m-auto">
            <div
                class="
                    flex flex-col-reverse
                    xl:flex-row
                    items-center
                    justify-center
                "
            >
                <div
                    class="
                        w-full
                        xl:w-2/5
                        2xl:w-1/2
                        flex
                        justify-center
                        items-center
                        flex-wrap
                        my-5
                    "
                >
                    <template
                        v-for="(value_image, idx_image) in [
                            currentPage.images.oImage1,
                            currentPage.images.oImage2,
                            currentPage.images.oImage3,
                            currentPage.images.oImage4,
                            currentPage.images.oImage5,
                            currentPage.images.oImage6,
                        ]"
                    >
                        <router-link
                            :to="{
                                name: 'catalogue',
                                params: { slug: value_image.href },
                            }"
                            class="
                                q10__card
                                md:w-50
                                m-1 lg:m-2
                                p-2
                                inline-block
                                bg-white
                                shadow-xl
                                text-center
                            "
                            :key="idx_image"
                        >
                            <div class="aspect-w-10 aspect-h-10">
                                <img
                                    :src="
                                        $i18n.locale +
                                        '/images/pages/' +
                                        currentPage.slug +
                                        '/' +
                                        value_image.src
                                    "
                                    :alt="value_image.alt"
                                    :style="{
                                        objectFit: 'cover',
                                    }"
                                />
                            </div>

                            <div
                                class="
                                    q10__cardTitle
                                    uppercase
                                    text-allports
                                    whitespace-nowrap
                                    leading-none
                                    font-bold
                                "
                                v-html="value_image.text"
                            ></div>
                        </router-link>
                    </template>
                </div>

                <div
                    class="w-full xl:w-1/2 my-5 md:text-white flex justify-end"
                >
                    <div class="md:max-w-md text-left xl:text-right">
                        <div class="container mb-4 2xl:mb-16">
                            <span
                                v-html="currentPage.content.sTextImage003.text"
                                class="xl:text-xl 2xl:text-3xl"
                            ></span>
                        </div>
                        <h3
                            v-html="currentPage.content.chapterTitle.text"
                            class="text-4xl 2xl:text-6xl mb-5"
                        ></h3>
                        <p
                            class="text-sm 2xl:text-base"
                            v-html="currentPage.content.chapterDescription.text"
                        ></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";

export default {
    name: "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
.q10__page {
    @media (max-width: 767px) {
        background-image: none !important;
        // height: 235px;
    }
}
.q10__card {
    width: 30%;
    @media (max-width: 1535px) {
        width: 28%;
    }
     @media (max-width: 767px) {
        width: 45%;
    }
}

.q10__cardTitle {
    @media (max-width: 1535px) {
        font-size: 9px;
    }
}
.curve-image {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 240px;
    @media (max-width: 1280px) {
        width: 160px;
    }
    @media (max-width: 1024px) {
        display: none;
    }
}
</style>
